(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video-audio"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.ag-hero-video__unmute');
  if (!btn) return;
  const id = btn.getAttribute('data-target');
  const vid = document.getElementById(id);
  if (!vid) return;

  try {
    vid.muted = false;
    const p = vid.play();
    if (p && typeof p.then === 'function') { p.catch(() => {}); }
  } catch (err) {}

  btn.style.display = 'none';
});

  } catch(e) { console.error(e); }
})();
})();
